import {
    apiRequest,
    pensiunList,
    pensiunActive,
    pensiunInactive,
    syaratDokumen,
    pensiunListMonitoring,
    listTahun,
    pensiunExport
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pensiunList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pensiunInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pensiunActive, {
            body: query
        }, true)
    }

    fetchSyaratDokumen = async (query) => {
        return await apiRequest("post", syaratDokumen, {
            body: query
        }, true)
    }

    fetchMonitoring = async (query) => {
        return await apiRequest("post", pensiunListMonitoring, {
            body: query
        }, true)
    }

    fetchTahun = async (query) => {
        return await apiRequest("get", listTahun, {
            body: query
        }, true)
    }

    
    fetchExport = async (query, cancelToken) => {
        return await apiRequest("get", pensiunExport, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

   
}

export default DataTableRepository